/* RESPONSIBLE TEAM: team-rd-services */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAiAgentAnalyzeMonitorNewScorecardAttributeNewValueRoute extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.new-scorecard.attribute-new.value',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAiAgentAnalyzeMonitorNewScorecardAttributeNewValueRoute);
